module.exports = __webpack_public_path__ + "media/images/icon_mypage_menu_on-95e148da8793c61cf481d9537301273d.png";